var map = {
	"./glassesblonde.gif": 3981,
	"./glassesdark.gif": 1065,
	"./laughing.gif": 4270,
	"./moustache.gif": 9710,
	"./oldnerd.gif": 4237,
	"./redhair.gif": 6195,
	"./suit.gif": 7597,
	"./talking.gif": 5500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1011;